module.exports = __webpack_public_path__ + "img/file-version.6f2f17d3.png";